import request from '@/utils/request'
import { guid } from "@/utils/ruoyi"

// ==================== 商品管理 ====================

/**
 * 查询商品分类列表
 */
export function listGoodsCategory(query) {
  return request({
    url: '/goods/category/list',
    method: 'get',
    params: query
  })
}

/**
 * 查询商品分页
 */
export function pageGoods(data) {
  data.date = guid()
  return request({
    url: '/goods/goods/page',
    method: 'post',
    data: data
  })
}

/**
 * 查询商品列表
 */
export function listGoods(query) {
  return request({
    url: '/goods/goods/list',
    method: 'get',
    params: query
  })
}

/**
 * 根据条码或SKU搜索商品
 */
export function searchGoodsBySku(skuCode) {
  return request({
    url: '/goods/goods/search',
    method: 'get',
    params: { skuCode }
  })
}

/**
 * 获取商品详情
 */
export function getGoodsDetail(id) {
  return request({
    url: '/goods/goods/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 根据商品ID获取SKU列表
 */
export function getSkuListByGoodsId(goodsId) {
  return request({
    url: '/goods/sku/app/list',
    method: 'get',
    params: { goodsId }
  })
}

/**
 * 获取SKU分页列表
 */
export function pageSku(data) {
  return request({
    url: '/goods/sku/page',
    method: 'get',
    params: data
  })
}
